import { MessageCircle } from "lucide-react";

export const WhatsAppFloat = () => (
  <a
    href="https://wa.me/14175140081"
    target="_blank"
    rel="noreferrer"
    data-testid="whatsapp-float"
    className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:scale-110 active:scale-95 text-white p-4 rounded-full shadow-[0_0_25px_rgba(37,211,102,0.5)] transition-transform flex items-center justify-center"
    aria-label="WhatsApp"
  >
    <MessageCircle className="w-6 h-6" strokeWidth={2} />
  </a>
);
